// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"93":"5f1e36b8","120":"805a2c15","431":"c8b1348c","633":"0b4be0ca","856":"c7084055","858":"f828aa8c","935":"5a2dc256"}[chunkId] + ".js";
};